<dashboard-dialog-frame [header]="header" [dialogRef]='dialogRef'>

	<div class="p-3 h-100 d-flex flex-column justify-content-between">
		<div>
			<common-url-field [field]="scheduleLink()"></common-url-field>
		</div>

		<div class="mt-3">
			<common-button-row [center]="true">
				<button class="btn btn-standard" #saveBtn>Save</button>
				<button class="btn btn-standard" (click)="form.resetAll()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>